module.exports = __webpack_public_path__ + "2e3de403c3ffd553f1c1fe3fce788e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/australia_icon.png
// module id = 1227
// module chunks = 0